import { render, staticRenderFns } from "./YourProjects.vue?vue&type=template&id=1b2997c6&scoped=true&"
import script from "./YourProjects.vue?vue&type=script&lang=js&"
export * from "./YourProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2997c6",
  null
  
)

export default component.exports